import AjaxForm from '../models/AjaxForm'
import flatpickr from 'flatpickr'
import 'flatpickr/dist/flatpickr.min.css'

function initTargetBlankForms () {
  document.querySelectorAll('form[target=_blank]').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault()
      form.submit()
      form.reset()
    })
  })
}

function initDateTimePickers () {
  flatpickr('.datepicker', {
    dateFormat: 'd.m.Y',
  })

  flatpickr('.timepicker', {
    enableTime: true,
    noCalendar: true,
    dateFormat: 'H:i',
    time_24hr: true,
  })
}

export default function () {
  initTargetBlankForms()
  document.querySelectorAll('[ajax-form]').forEach(form => new AjaxForm(form))
  initDateTimePickers()
}
